// Same-tab + cross-tab notification that a database's filter config changed
// (mirrors lib/menuVisibilityBus.js).
const EVENT = "cpg:db-filters-changed";
const CHANNEL = "cpg-db-filters";

function channel() {
  try { return typeof window.BroadcastChannel === "function" ? new window.BroadcastChannel(CHANNEL) : null; }
  catch { return null; }
}

export function broadcastDbFiltersChanged(slug) {
  try { window.dispatchEvent(new CustomEvent(EVENT, { detail: { slug } })); } catch { /* noop */ }
  const ch = channel();
  if (ch) { try { ch.postMessage({ slug }); ch.close(); } catch { /* noop */ } }
}

export function subscribeDbFilters(callback) {
  const onWin = (e) => callback(e.detail?.slug);
  window.addEventListener(EVENT, onWin);
  const ch = channel();
  if (ch) ch.onmessage = (e) => callback(e.data?.slug);
  return () => {
    window.removeEventListener(EVENT, onWin);
    if (ch) ch.close();
  };
}
